import { gql } from "@apollo/client";

export const CREAR_EGRESO = gql`
  mutation CREAR_EGRESO(
    $input: InputEgreso
    $cobro: InputMovimiento
    $archivo: Upload
  ) {
    crearEgreso(input: $input, cobro: $cobro, archivo: $archivo)
  }
`;

export const OBTENER_EGRESOS_DIA = gql`
  query OBTENER_EGRESOS {
    obtenerEgresos {
      id
      descripcion
      fechaEgreso
      createdAt
      CatEgresosModel {
        clave
      }
      MovimientosModel {
        monto
        createdAt
      }
      detalleCuentasEgresosModel {
        clave
        descripcion
      }
    }
  }
`;

export const OBTENER_CAT_EGRESOS = gql`
  query OBTENER_CAT_EGRESOS {
    obtenerCategoriasEgresos {
      id
      clave
      descripcion
    }
  }
`;
export const OBTENER_SUB_EGRESOS = gql`
  query OBTENER_SUB_EGRESOS($CatEgresos: ID!) {
    obtenerDetallesEgresos(CatEgresos: $CatEgresos) {
      clave
      descripcion
    }
  }
`;
export const ELIMINAR_EGRESO = gql`
  mutation ELIMINAR_EGRESO($id: ID) {
    eliminarEgreso(id: $id)
  }
`;

export const AGREGAR_CAT_EGRESO = gql`
  mutation AGREGAR_CAT_EGRESO($input: InputCategresos) {
    agregarCategoriaEgresos(input: $input)
  }
`;

export const OBTENER_SUBEGRESOS = gql`
  query OBTENER_SUBEGRESOS {
    obtenerDetalleEgresos {
      clave
      descripcion
      CatEgresosId
    }
  }
`;

export const AGREGAR_SUBCAT_EGRESO = gql`
  mutation AGREGAR_SUBCAT_EGRESO($input: InputSubcuentaEgresos) {
    agregarCategoriaSubEgresos(input: $input)
  }
`;
export const ELIMINAR_SUBCUENTAEGRESO = gql`
   mutation ELIMINAR_SUNCUENTAEGRESO($clave:ID!) {
    eliminarDetalleEgreso(clave:$clave)

  }
`;
